/** Stable query key factories — include userId in keys for personalized data. */

export const queryKeys = {
  genres: () => ['events', 'genres'],

  events: {
    feed: (filters) => ['events', 'feed', filters],
    trending: (userId) => ['events', 'trending', userId ?? null],
    festivals: () => ['events', 'festivals'],
    cancelled: () => ['events', 'cancelled'],
    search: (query, userId) => ['events', 'search', { q: query, userId: userId ?? null }],
    detail: (eventId) => ['events', 'detail', eventId],
    detailRsvps: (eventId) => ['events', 'detail', eventId, 'rsvps'],
    lineup: (eventId) => ['events', 'lineup', eventId],
    headliners: (eventIds) => ['events', 'headliners', 2, eventIds], // 2: a list per event (co-headliners), was one artist
    lineupMutualVoters: (eventId, userId) => ['events', 'lineup', eventId, 'mutual-voters', userId],
    myArtistVotes: (eventId, userId) => ['events', 'lineup', eventId, 'votes', userId],
    myAttendance: (eventId, userId) => ['events', 'lineup', eventId, 'attendance', userId],
    attendanceByUsers: (eventId) => ['events', 'lineup', eventId, 'attendance-by-users'],
  },

  sets: {
    index: () => ['sets', 'index', 2], // 2: rows carry hero/card images (the tiles, 2026-10-28)
    past: (eventIds) => ['sets', 'past', 2, eventIds],
  },

  rsvps: {
    mine: (userId) => ['rsvps', 'mine', userId],
    goingEvents: (eventIds) => ['rsvps', 'going-events', eventIds],
  },

  profiles: {
    detail: (userId, mode) => ['profiles', userId, mode],
    events: (userId) => ['profiles', userId, 'events'],
    viewerRsvps: (userId, eventIds) => ['profiles', 'viewer-rsvps', userId, eventIds],
  },

  people: {
    /** picked ring colours of you and the people you know (get_people_hues, migration 173) */
    hues: (userId) => ['people', 'hues', userId],
    following: (userId) => ['people', 'following', userId],
    followers: (userId) => ['people', 'followers', userId],
    suggested: (userId, limit = 20) => ['people', 'suggested', userId, limit],
    suggestedDiscover: (userId) => ['people', 'suggested-discover', userId],
    search: (userId, query, limit = 20) => ['people', 'search', userId, query, limit],
  },

  chats: {
    inbox: (userId) => ['chats', 'inbox', userId],
    pending: (userId) => ['chats', 'pending', userId],
    dm: (conversationId) => ['chats', 'dm', conversationId],
    dmMessages: (conversationId) => ['chats', 'dm', conversationId, 'messages'],
    group: (groupId) => ['groups', groupId],
    groupMessages: (groupId) => ['groups', groupId, 'messages'],
    groupMembership: (groupId, userId) => ['groups', groupId, 'membership', userId],
    memberVoters: (groupId, eventId) => ['groups', groupId, 'member-voters', eventId],
  },

  find: {
    groups: (userId) => ['find', 'groups', userId],
    members: (userId, groupIds) => ['find', 'members', userId, groupIds],
  },

  festivalMap: {
    published: (eventId) => ['festival-map', eventId],
    mine: (userId) => ['festival-map', 'mine', userId, 2], // 2: rows carry cover_url (166)
    upcoming: () => ['festival-map', 'upcoming', 2],
  },

  studio: {
    maps: () => ['studio', 'maps'],
    map: (editionId) => ['studio', 'map', editionId],
  },

  notifications: {
    unreadCount: (userId) => ['notifications', 'unread-count', userId],
    list: (userId, filter) => ['notifications', 'list', userId, filter],
  },
};
